import { render, staticRenderFns } from "./attachmentList.vue?vue&type=template&id=478a6e08&scoped=true"
import script from "./attachmentList.vue?vue&type=script&lang=js"
export * from "./attachmentList.vue?vue&type=script&lang=js"
import style0 from "./attachmentList.vue?vue&type=style&index=0&id=478a6e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a6e08",
  null
  
)

export default component.exports